import { post } from "@/utils/utils";

const memberMarketing = {
  state: {
    smsTemplatesList: {}
  },
  mutations: {
    QUERY_SMS_TEMPLATES_LIST(state, data) {
      state.smsTemplatesList = data.result;
    },
    QUERY_TEMPLATES_TYPE_LIST(state, data) {
      state.templatesTypeList = data.result;
    },
    SAVE_SMS_TEMPLATES(state, data) {
      state.saveSmsTemplates = data.result;
    },
    DETAILS_SMS_TEMPLATES(state, data) {
      state.detailsSmsTemplates = data.result;
    },
    EDIT_SMS_TEMPLATES(state, data) {
      state.editSmsTemplates = data.result;
    },
    QUERY_GUIDER_MARKET_LIST(state, data) {
      state.guiderMarketList = data.result;
    },
    QUERY_ALL_GUIDER_MARKET_LIST(state, data) {
      state.allguiderMarketList = data.result;
    },
    UPDATE_MARKET_CHECK(state, data) {
      state.updateMarketCheck = data.result;
    },
    QUERY_MARKETING_TEMPLATE_LIST(state, data) {
      state.marketingTemplateList = data.result;
    },
    UPDATE_MARKETING_TEMPLATE(state, data) {
      state.updateMarketingTemplate = data.result;
    },
    SAVE_MARKETING_TEMPLATE(state, data) {
      state.saveMarketingTemplate = data.result;
    },
    FIND_COUPON_SEND(state, data) {
      state.findCouponSendByEvent = data.result;
    }
  },
  actions: {
    querySmsTemplatesList({ commit }, params) {
      return post({
        commit,
        url: `/storeSmsTemplatesConfig/findSmsTemplatesList`,
        name: "QUERY_SMS_TEMPLATES_LIST",
        params
      });
    },
    queryTemplatesTypeList({ commit }, params) {
      return post({
        commit,
        url: `/storeSmsTemplatesConfig/findTemplateTypeList`,
        name: "QUERY_TEMPLATES_TYPE_LIST",
        params
      });
    },
    saveSmsTemplates({ commit }, params) {
      return post({
        commit,
        url: `/storeSmsTemplatesConfig/saveSmsTemplates`,
        name: "SAVE_SMS_TEMPLATES",
        params
      });
    },
    detailsSmsTemplates({ commit }, params) {
      return post({
        commit,
        url: `/storeSmsTemplatesConfig/findSmsTemplatesById`,
        name: "DETAILS_SMS_TEMPLATES",
        params
      });
    },
    editSmsTemplates({ commit }, params) {
      return post({
        commit,
        url: `/storeSmsTemplatesConfig/editSmsTemplates`,
        name: "EDIT_SMS_TEMPLATES",
        params
      });
    },
    queryGuiderMarketList({ commit }, params) {
      return post({
        commit,
        url: `/guider/market/market_check_page`,
        name: "QUERY_GUIDER_MARKET_LIST",
        params
      });
    },
    queryAllGuiderMarketList({ commit }, params) {
      return post({
        commit,
        url: `/guider/market/market_check_page`,
        name: "QUERY_ALL_GUIDER_MARKET_LIST",
        params
      });
    },
    updateMarketCheck({ commit }, params) {
      return post({
        commit,
        url: `/guider/market/upd_market_check`,
        name: "UPDATE_MARKET_CHECK",
        params
      });
    },
    queryMarketingTemplateList({ commit }, params) {
      return post({
        commit,
        url: `/guider/market/marketing_template_list`,
        name: "QUERY_MARKETING_TEMPLATE_LIST",
        params
      });
    },
    updateMarketingTemplate({ commit }, params) {
      return post({
        commit,
        url: `/guider/market/upd_marketing_template`,
        name: "UPDATE_MARKETING_TEMPLATE",
        params
      });
    },
    saveMarketingTemplate({ commit }, params) {
      return post({
        commit,
        url: `/guider/market/save_marketing_template`,
        name: "SAVE_MARKETING_TEMPLATE",
        params
      });
    },
    findCouponSendList({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendByEvent`,
        name: "FIND_COUPON_SEND",
        params
      });
    }
  }
};

export default memberMarketing;
